import React from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

import { events } from "@planzone/events";
import { useMessage } from "@components/useMessage";
import { Props } from "./types";
import { CostProfile } from "./costProfile";
import styles from "./styles.scss";

function sanitize(str: string) {
  return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

function CostProfiles({ costProfiles, resource, select }: Props) {
  const { t } = useTranslation();
  const [searchQuery, setSearchQuery] = React.useState("");

  useMessage(
    ({ type, data }) =>
      type === events.assignCostProfileToResourceSucceeded && select(),
  );

  return (
    <div className={styles.costProfiles}>
      <div className={styles.search}>
        <input
          className={styles.input}
          placeholder={t("editResource.search")}
          value={searchQuery}
          onChange={({ target }) => setSearchQuery(target.value)}
        />
      </div>
      {costProfiles
        .filter(({ name }) => new RegExp(sanitize(searchQuery), "i").test(name))
        .map((costProfile) => (
          <div
            key={costProfile.uuid}
            className={classNames(styles.costProfile, {
              [styles.selected]:
                resource.costProfile &&
                resource.costProfile.uuid === costProfile.uuid,
            })}
          >
            <CostProfile costProfile={costProfile} resource={resource} />
          </div>
        ))}
    </div>
  );
}

export { CostProfiles };
